import React, { Component, createRef } from "react";
import { Form, Input, Button, Select } from "antd";
import { MinusCircleOutlined, PlusOutlined } from "@ant-design/icons";
import { getAllGames } from "@api/statistics";

const Option = Select.Option;
let id = 0;
let allGames = [];
let selectedGames = [];
let deleteGame = {};

class PriceInput extends React.Component {
    static getDerivedStateFromProps(nextProps) {
        // Should be a controlled component.
        if ("value" in nextProps) {
            return {
                ...(nextProps.value || {})
            };
        }
        return null;
    }

    constructor(props) {
        super(props);
        
        const currentGame = props.currentGame || {};
        this.getAllGames();

        if (JSON.stringify(currentGame) !== "{}") {
            this.state = {
                value: currentGame.value || 0,
                gameId: currentGame.gameId || ""
            };
            this.triggerChange(currentGame);
        }
    }

    getAllGames = async () => {
        const res = await getAllGames();
        const games = res.data.data || [];

        if (allGames.length > 0) {
            this.setState({ allGames });
        } else {
            allGames = games.map(item => ({
                value: item.gameId,
                label: item.gameName || item.gameId
            }));

            this.setState({ allGames });
        }
    };

    handleValueChange = e => {
        const value = parseInt(e.target.value || 0, 10);

        if (Number.isNaN(value)) {
            return;
        }
        if (!("value" in this.props)) {
            this.setState({ value });
        }
        this.triggerChange({ value });
    };

    handleGameChange = gameId => {
        if (!("value" in this.props)) {
            this.setState({ gameId });
        }
        this.triggerChange({ gameId });
    };

    triggerChange = changedValue => {
        // Should provide an event to pass value to Form.
        const onChange = this.props.onChange;

        if (onChange) {
            const tempValue = this.state.value;
            const tempGameId = this.state.gameId;
            const { gameId } = changedValue;
            const { tempkey } = this.props;

            if (gameId) {
                selectedGames = [];
                deleteGame[tempkey] = gameId;

                for (const key in deleteGame) {
                    selectedGames.push(deleteGame[key]);
                }
            }

            onChange(
                Object.assign(
                    {},
                    { value: tempValue, gameId: tempGameId },
                    changedValue
                )
            );
        }
    };

    render() {
        const { size, cooperateType } = this.props;
        const state = this.state;

        return (
            <span style={{ display: "inline-block", marginLeft: "50px" }}>
                <Select
                    value={state.gameId}
                    size={size}
                    style={{ width: "150px", display: "inline-block" }}
                    onChange={this.handleGameChange}
                    placeholder="请选择游戏"
                >
                    {allGames.map((item, index) => {
                        return (
                            <Option
                                value={item.value}
                                key={index}
                                disabled={selectedGames.includes(item.value)}
                            >
                                {item.label}
                            </Option>
                        );
                    })}
                </Select>
                <Input
                    type="text"
                    size={size}
                    value={state.value}
                    onChange={this.handleValueChange}
                    style={{ width: "300px", marginLeft: "8px" }}
                    placeholder={
                        cooperateType === "cps"
                            ? "请输入分成比例"
                            : "请输入单价"
                    }
                />
            </span>
        );
    }
}

class ConfigForm extends Component {
    formRef = createRef();

    constructor(props) {
        super(props);

        selectedGames = [];
        deleteGame = {};
    }

    state = {
        cooperateType: "",
        cooperateGames: [],
        keys: []
    };

    componentDidMount() {
        const {
            cooperateType,
            cooperatePrice,
            reward,
            cooperateGames
        } = this.props.configData;

        this.setState({ cooperateType, cooperateGames });

        this.formRef.current &&
            this.formRef.current.setFieldsValue({
                cooperateType,
                cooperatePrice,
                reward
            });

        if (Array.isArray(cooperateGames)) {
            let keys = [];
            cooperateGames.forEach(() => {
                keys.push(id++);
            });
            this.setState({ keys });
        }
    }

    remove = k => {
        selectedGames = selectedGames.filter(item => item !== deleteGame[k]);
        delete deleteGame[k];

        const { keys } = this.state;
        // We need at least one passenger
        if (keys.length === 1) {
            return;
        }

        this.setState({
            keys: keys.filter(key => key !== k)
        });
    };

    add = () => {
        const { keys } = this.state;
        const nextKeys = keys.concat(id++);
        this.setState({ keys: nextKeys });
    };

    handleSubmit = async () => {
        try {
            const values = await this.formRef.current.validateFields();
            const {
                cooperateGames,
                cooperatePrice,
                cooperateType,
                reward
            } = values;
            
            const { keys } = this.state;
            const tempCooperateGames = keys.map(key => cooperateGames[key]);
            const data = {
                cooperateGames: tempCooperateGames,
                cooperateType,
                cooperatePrice: Number(cooperatePrice),
                reward: Number(reward)
            };

            this.props.saveCallBack(data);
        } catch (err) {
            console.log(err);
        }
    };

    handleTypeChange = data => {
        selectedGames = [];
        deleteGame = {};
        this.setState({ cooperateType: data });
        this.formRef.current &&
            this.formRef.current.setFieldsValue({
                cooperateType: data,
                cooperatePrice: 0,
                reward: 0
            });

        this.setState({ keys: [], cooperateGames: [] }, () => {
            this.add();
        });
    };

    render() {
        const { cooperateType, cooperateGames, keys } = this.state;
        const { typeList } = this.props;
        const formItemLayout = {
            labelCol: {
                xs: { span: 24 },
                sm: { span: 4 }
            },
            wrapperCol: {
                xs: { span: 24 },
                sm: { span: 20 }
            }
        };

        const formItemLayoutWithOutLabel = {
            labelCol: {
                xs: { span: 4 },
                sm: { span: 4 }
            },
            wrapperCol: {
                xs: { span: 20 },
                sm: { span: 20 }
            }
        };

        const formItems = keys.map((k, index) => (
            <Form.Item
                {...(index === 0 ? formItemLayout : formItemLayoutWithOutLabel)}
                label={index === 0 ? "" : ""}
                required={false}
                key={k}
                name={['cooperateGames', k]}
            >
                <PriceInput
                    tempkey={k}
                    cooperateType={cooperateType}
                    currentGame={cooperateGames && cooperateGames[index]}
                />
                {keys.length > 1 ? (
                    <div
                        style={{
                            display: "inline-block",
                            marginLeft: "8px",
                            cursor: "pointer"
                        }}
                        onClick={() => this.remove(k)}
                    >
                        <MinusCircleOutlined className="dynamic-delete-button" />
                        <span style={{ marginLeft: "3px", color: "#1890ff" }}>
                            删除
                        </span>
                    </div>
                ) : null}
            </Form.Item>
        ));

        return (
            <Form ref={this.formRef} onFinish={this.handleSubmit}>
                <Form.Item 
                    label="合作方式" 
                    {...formItemLayoutWithOutLabel}
                    name="cooperateType"
                    rules={[
                        {
                            required: true,
                            message: "请选择合作方式"
                        }
                    ]}
                >
                    <Select
                        placeholder="请选择合作方式"
                        style={{ display: "inline-block", width: "200px" }}
                        onChange={this.handleTypeChange}
                    >
                        {typeList.map((item, index) => {
                            return (
                                <Option value={item.value} key={index}>
                                    {item.label}
                                </Option>
                            );
                        })}
                    </Select>
                </Form.Item>
                <Form.Item
                    label="默认分成比例"
                    {...formItemLayoutWithOutLabel}
                    name="reward"
                    style={{
                        display: cooperateType === "cps" ? "block" : "none"
                    }}
                    rules={[
                        {
                            required: true,
                            message: "请输入分成比例"
                        }
                    ]}
                >
                    <Input
                        type="number"
                        style={{ width: "300px" }}
                        placeholder="请输入正整数，如200"
                    />
                    <span> %</span>
                </Form.Item>
                <Form.Item
                    label="默认单价"
                    {...formItemLayoutWithOutLabel}
                    name="cooperatePrice"
                    style={{
                        display: cooperateType === "cpa" ? "block" : "none"
                    }}
                    rules={[
                        {
                            required: true,
                            message: "请输入默认单价"
                        }
                    ]}
                >
                    <Input
                        type="number"
                        style={{ width: "300px" }}
                        placeholder="请输入正整数，如200"
                    />
                    <span> 分</span>
                </Form.Item>
                <div
                    style={{
                        color: "rgba(0, 0, 0, 0.85)",
                        marginLeft: "50px",
                        marginBottom: "10px"
                    }}
                >
                    {cooperateType === "cps" ? "特殊游戏分成" : "特殊游戏单价"}
                </div>

                <div
                    style={{
                        display: cooperateType === "cps" ? "block" : "none"
                    }}
                >
                    {formItems}
                </div>
                <div
                    style={{
                        display: cooperateType === "cpa" ? "block" : "none"
                    }}
                >
                    {formItems}
                </div>
                <Form.Item {...formItemLayoutWithOutLabel}>
                    <Button
                        type="dashed"
                        onClick={this.add}
                        style={{ width: "60%", marginLeft: "50px" }}
                    >
                        <PlusOutlined />
                        <span style={{ marginLeft: "3px", color: "#1890ff" }}>
                            添加游戏
                        </span>
                    </Button>
                </Form.Item>
                <Form.Item {...formItemLayoutWithOutLabel}>
                    <div style={{ textAlign: "center" }}>
                        <Button type="primary" htmlType="submit">
                            保存
                        </Button>
                    </div>
                </Form.Item>
            </Form>
        );
    }
}

export default ConfigForm;
